import { useEffect } from 'react';
import { useInnerPanelOpen } from './customModalFullscreen';

// Vysúvací panel vykresľovaný PRIAMO v strome (BEZ portálu do document.body) - na rozdiel od
// CustomModal/CustomModalLarge. Používa sa vnútri CustomModalFullscreen: ten má nastavený CSS
// transform, ktorý podľa špecifikácie vytvára containing block pre position:fixed potomkov,
// takže tento panel prekrýva presne viditeľnú oblasť fullscreen modalu (nie celý viewport) a
// "nescrolluje" sa spolu s obsahom pod ním. Vďaka tomu, že nejde o portál/ďalší modal navrchu,
// sa vyhneme stohovaniu viacerých modalov na sebe (a s tým súvisiacim z-index a ESC problémom).
//
// ESC zachytávame v capture fáze a hneď zastavíme propagáciu (len kým je panel viditeľný), aby
// zatvorilo LEN tento panel, nie aj fullscreen modal pod ním - druhé stlačenie ESC zatvorí aj ten.
const CustomModalInline = ({ isVisible, onClose, children }) => {
    // Kým je tento panel otvorený, nadradený CustomModalFullscreen schová svoje vlastné
    // tlačidlo na zatvorenie (inak by boli vedľa seba dve krížiky).
    useInnerPanelOpen(isVisible);

    useEffect(() => {
        if (!isVisible) return;

        const handleEscKey = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscKey, true);
        return () => {
            document.removeEventListener('keydown', handleEscKey, true);
        };
    }, [isVisible, onClose]);

    return (
        <>
            {/* Overlay - prekrýva len obsah fullscreen modalu, nie celú obrazovku */}
            <div
                className={`custom-modal-inline-overlay ${isVisible ? 'visible' : ''}`}
                onClick={onClose}
            ></div>

            {/* Panel */}
            <div className={`custom-modal-inline ${isVisible ? 'visible' : ''}`}>
                <div className="custom-modal-inline-content">
                    <button className="close-button" onClick={onClose}>×</button>
                    {children}
                </div>
            </div>
        </>
    );
};

export default CustomModalInline;
